jQuery(document).ready(function ($) {
        //############################################//
        //###*****   Card link drawers
        //############################################//  

        const mq = window.matchMedia("(min-width: 768px)");
        if (mq.matches) {
            
            

        }



        $(".js-card-link").hover(function() {
                
            $(".m-card-links__float", this).stop(true,true).delay(100).animate({'bottom': '0' },200).addClass('open');
            
        }, function() {
            
            $(".m-card-links__float", this).stop(true,true).delay(100).animate({'bottom': '-34' },200).removeClass('open');
        
        });


    })
